import vue from 'vue';
export default function buildManagerStore(store){
    store.actions.findCoreUsers = async (context, params) => vue.prototype.$myHttp.post('/api/managers/findCoreUsers', params);
    return store;
}